<template lang="pug">

.board

  section.board-intro
    AppTitle.u-mb-sm(:title="$t('mantra')")
    AppLink(to="https://baianat.github.io/board/" class="button-link is-white" :title="$t('demo')") {{$t('demo')}}

    .board-intro-logo: AppIcon(name="logoBoardIcon")

  .board-features.u-mt-lg
    .u-textCenter
      h2.u-mb-mi {{$t('features')}}
    .grid.is-desktop-4.is-tablet-6
      .column.u-mb-sm
        .board-feature-h.u-textCenter
          img(src='https://cdn.baianat.com/static/resources/board/1.png', srcset='https://cdn.baianat.com/static/resources/board/1.png 1x, https://cdn.baianat.com/static/resources/board/1@2x.png 2x')
          h4.u-mt-xs {{$t('functional')}}
      .column.u-mb-sm
        .board-feature-h.u-textCenter
          img(src='https://cdn.baianat.com/static/resources/board/2.png', srcset='https://cdn.baianat.com/static/resources/board/2.png 1x, https://cdn.baianat.com/static/resources/board/2@2x.png 2x')
          h4.u-mt-xs {{$t('clear')}}
      .column.u-mb-sm
        .board-feature-h.u-textCenter
          img(src='https://cdn.baianat.com/static/resources/board/3.png', srcset='https://cdn.baianat.com/static/resources/board/3.png 1x, https://cdn.baianat.com/static/resources/board/3@2x.png 2x')
          h4.u-mt-xs {{$t('minimal')}}
      .column.u-mb-sm
        .board-feature-h.u-textCenter
          img(src='https://cdn.baianat.com/static/resources/board/4.png', srcset='https://cdn.baianat.com/static/resources/board/4.png 1x, https://cdn.baianat.com/static/resources/board/4@2x.png 2x')
          h4.u-mt-xs {{$t('customizable')}}
      .column.u-mb-sm
        .board-feature-h.u-textCenter
          img(src='https://cdn.baianat.com/static/resources/board/5.png', srcset='https://cdn.baianat.com/static/resources/board/5.png 1x, https://cdn.baianat.com/static/resources/board/5@2x.png 2x')
          h4.u-mt-xs {{$t('darkTheme')}}



  section.u-mt-lg
    .grid.is-middle
      .column.is-desktop-5.is-tablet-6.u-mb-sm
        h3 {{$t('diverse')}}
        p.u-text-lg {{$t('diverseDesc')}}
      .column.is-desktop-7.is-tablet-6.u-mb-sm
        img.board-shadow( src='https://cdn.baianat.com/static/resources/board/6.jpg', srcset='https://cdn.baianat.com/static/resources/board/6.jpg 1x, https://cdn.baianat.com/static/resources/board/6@2x.jpg 2x')
    .u-mt-lg.u-textCenter

      h2 {{$t('consistent')}}
    .grid.is-widescreen-6.is-desktop-8.is-tablet-9.is-center
      .column
        p.u-text-lg {{$t('consistentDesc')}}

    .u-mt-md
      img(srcset="https://cdn.baianat.com/static/resources/board/7.png 1x, https://cdn.baianat.com/static/resources/board/7@2x.png 2x")


    .u-mt-md.u-textCenter
      h2  {{$t('icons')}}
      .grid.is-widescreen-6.is-desktop-8.is-tablet-9.is-center
        .column
          p.u-text-lg  {{$t('iconsDesc')}}



  section.board-gray.u-mt-lg
    .grid.is-middle
      .column.is-desktop-7.is-tablet-6.u-mb-sm
        img( src='https://cdn.baianat.com/static/resources/board/8.png', srcset='https://cdn.baianat.com/static/resources/board/8.png 1x, https://cdn.baianat.com/static/resources/board/8@2x.png 2x')
      .column.is-desktop-5.is-tablet-6.u-mb-sm
        h3 {{$t('time')}}
        p.u-text-lg {{$t('timeDesc')}}

  section.u-mt-lg
    .grid.is-middle
      .column.is-desktop-5.is-tablet-6.u-mb-sm
        h3 {{$t('charts')}}
        p.u-text-lg {{$t('chartsDesc')}}
      .column.is-desktop-7.is-tablet-6.u-mb-sm
        img( src='https://cdn.baianat.com/static/resources/board/9.png', srcset='https://cdn.baianat.com/static/resources/board/9.png 1x, https://cdn.baianat.com/static/resources/board/9@2x.png 2x')

  section.u-mt-lg
    .grid.is-middle
      .column.is-desktop-7.is-tablet-6.u-mb-sm
        img( src='https://cdn.baianat.com/static/resources/board/10.png', srcset='https://cdn.baianat.com/static/resources/board/10.png 1x, https://cdn.baianat.com/static/resources/board/10@2x.png 2x')
      .column.is-desktop-5.is-tablet-6.u-mb-sm
        h3 {{$t('datatables')}}
        p.u-text-lg {{$t('datatablesDesc')}}


    .u-mt-md.u-textCenter
      AppTitle(:title="$t('brandIdentity')" tag="h2")
      .grid.is-widescreen-6.is-desktop-8.is-tablet-9.is-center
        .column
          p.u-text-lg {{$t('brandIdentityDesc')}}

    .u-mt-md
      img(srcset="https://cdn.baianat.com/static/resources/board/11.png 1x, https://cdn.baianat.com/static/resources/board/11@2x.png 2x")

    .grid.is-middle.u-mt-md
      .column.is-desktop-7.is-tablet-6.u-mb-sm
        img( src='https://cdn.baianat.com/static/resources/board/12.png', srcset='https://cdn.baianat.com/static/resources/board/12.png 1x, https://cdn.baianat.com/static/resources/board/12@2x.png 2x')
      .column.is-desktop-5.is-tablet-6.u-mb-sm
        h3 {{$t('alternativeDark')}}
        p.u-text-lg {{$t('alternativeDarkDesc')}}

    .grid.is-middle.u-mt-md
      .column.is-desktop-7.is-tablet-6.u-mb-sm
        img( src='https://cdn.baianat.com/static/resources/board/13.png', srcset='https://cdn.baianat.com/static/resources/board/13.png 1x, https://cdn.baianat.com/static/resources/board/13@2x.png 2x')
      .column.is-desktop-5.is-tablet-6.u-mb-sm
        h3 {{$t('incorporated')}}
        p.u-text-lg {{$t('incorporatedDesc')}}


  section.board-cta.u-mt-lg
    AppTitle(:title="$t('experienceBoard')" tag="h2")



    AppLink(to="https://github.com/baianat/board" class="button-link is-white" :title="$t('getStarted')") {{$t('getStarted')}}





  .u-mb-md

</template>
<style lang="stylus">
$clMain = rgb(6, 215, 123)
$clGreen = #00a14f
$clGray = #869daf

div.app.is-board
  overflow: hidden

  .header
    a:hover
      color: $clSecondary

  .header.is-scroll
    background: $clPrimary
    color: $clWhite !important

    a:hover
      color: $clSecondary

.board
  position: relative

  &-shadow
    box-shadow: 0px 20px 59.5px 10.5px rgba(28, 29, 31, 0.07)

  &-intro
    padding-top: unitRes(200, 400)
    padding-bottom: unitRes(120, 240)
    margin-left: -12vw
    margin-right: -12vw
    padding-right: 8vw
    padding-left: 8vw
    z-index: 1
    position: relative
    background: $clPrimary
    color: $clWhite
    overflow: hidden
    text-shadow: 1px 1px 11px alpha($clBlack, 0.2)

    h1
      +mq($until: 'mobile')
        font-size: unitRes(32, 80)

    &-logo
      position: absolute
      right: -8%
      bottom: -40%
      z-index: -1

      .icon
        width: 800px
        height: 1000px

        +mq($until: 1550px)
          width: 600px
          height: 750px

        +mq($until: 'desktop')
          width: 400px
          height: 500px

        +mq($until: 'mobile')
          width: 300px
          height: 380px

    .button-link.is-white:hover, .button-link.is-white.is-active
      color: $clSecondary
      background-image: linear-gradient(to right, $clSecondary 0%, $clSecondary 100%)

  &-feature
    &-h
      img
        max-height: 230px

        +mq($until: 1400px)
          max-height: 160px

      p
        max-width: 400px
        margin-right: auto
        margin-left: auto

  &-gray
    background: $clGray
    padding: 8vw 8vw 4vw
    margin-right: -12vw
    margin-left: -12vw
    color: $clWhite

  &-cta
    background-color: $clPrimary
    padding: unitRes(20, 160)
    color: $clWhite
    background-image: url('https://cdn.baianat.com/static/resources/board/14.png')
    background-repeat: repeat-y
    background-position: 90% center
    background-attachment: fixed
    text-shadow: 1px 1px 11px alpha($clBlack, 0.2)

    .button-link.is-white:hover, .button-link.is-white.is-active
      color: $clSecondary
      background-image: linear-gradient(to right, $clSecondary 0%, $clSecondary 100%)

    +mq($until: 'widescreen')
      background-size: 40%

    +mq($until: 'desktop')
      margin-left: -12vw
      margin-right: -12vw
      padding-left: 8vw
      padding-right: 8vw

html[lang^='ar']
  .board
    &-cta
      background-position: 10% center

    &-intro
      &-logo
        right: auto
        left: -8%
</style>

<script>
import Prism from '~/components/Prism';
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,
  meta: {
    theme: 'is-board is-fixedHeader is-whiteHeader',
    logoText: 'logoBoardTypo',
    logoIcon: 'logoBoardIcon'
  },

  head: generateSeoMeta(
    {
      title: 'pageTitle',
      description: 'pageDesc'
    },
    { i18n: true }
  ),

  components: {
    Prism
  },
  data: () => ({
    install: `npm install verte
# or use yarn
yarn add verte

# Usage

<template>
  <verte picker="square" model="rgb"></verte>
</template>

<script>
  import Verte from 'verte';
  import 'verte/dist/verte.css';
  // register component globally
  Vue.component(Verte.name, Verte);

  new Vue ({
    el: '#app',
    // OR register locally
    components: { Verte }
  });
<\/script>
`
  })
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Board",
    "pageDesc":"Use board admin panel to easily manage your website. Board comes with different layouts and customizations to suit your brand.",
    "mantra":"Elegant admin panel.",
    "demo":"Demo",
    "features":"Features",
    "functional":"Functional",
    "clear":"Clear",
    "minimal":"Minimal",
    "customizable":"Customizable",
    "darkTheme":"Dark theme",
    "diverse":"Diverse components",
    "diverseDesc":"Board comes with plenty of components, ready to be part of your next dashboard layout.",
    "consistent":"Consistent Design",
    "consistentDesc":"Sticking to Board will make your dashboard look and feel consistent, since it’s all implemented using our Blexar design system.",
    "icons":"+800 Icons",
    "iconsDesc":"Enjoy a variety of neatly-crafted icons made for different occasions. The icons provided in Board are part of Blexar framework and come in both outlined and filled formats.",
    "time":"Time saving",
    "timeDesc":"Construct your UI by putting Board components together. You will find all you need and more at your fingertips.",
    "charts":"Visualize with Charts",
    "chartsDesc":"Board comes with various chart components for better demonstration of different statistics to be laid in your UI.",
    "datatables":"Inclusive Datatables",
    "datatablesDesc":"Display your data in an organized manner and have full control over it for both client and server side processing.",
    "brandIdentity":"Highlighting brand |identity",
    "brandIdentityDesc":"Set the theme color and logo according to the brand you are building the dashboard for to achieve a personalized look and feel.",
    "alternativeDark":"Alternative dark theme",
    "alternativeDarkDesc":"There is a dark theme of Board that packs a different taste. More themes will follow in the future as well.",
    "incorporated":"Incorporated Libraries",
    "incorporatedDesc":"Find different third party libraries; including editors and input components, styled to fit with Board’s ecosystem.",
    "experienceBoard":"Experience elegance |with Board.",
    "getStarted":"Get started"
  },
  "ar": {
    "pageTitle":"Board",
    "pageDesc":"استخدم لوحة التحكم الأنيقة من تصميم بيانات لإدارة موقعك بسهولة تأتي Board بمخططات وتخصيصات مختلفة لتناسب علامتك التجارية",
    "mantra":"واجهة مستخدم أنيقة |للوحات التحكم.",
    "demo":"عرض",
    "features":"المميزات",
    "functional":"وظيفية",
    "clear":"واضحة",
    "minimal":"بسيطة",
    "customizable":"مخصصة",
    "darkTheme":"قوالب داكنة",
    "diverse":"مكونات متنوعة",
    "diverseDesc":"تأتي Board مع الكثير من المكونات الجاهزة لتكون جزءًا من تنسيق لوحة التحكم التالية.",
    "consistent":"تصميم متناغم",
    "consistentDesc":"الاعتماد على Board سوف يمنح لوحة التحكم الخاصة بك مظهر متماسك، حيث يتم تنفيذه اعتمادًا على نظام التصميم الخاص بنا بلكسر.",
    "icons":"أكثر من 800 أيقونة",
    "iconsDesc":"تمتع بمجموعة متنوعة من الأيقونات المصنوعة بعناية للموضوعات المختلفة. تمثل الرموز المقدمة في Board جزءًا من إطار عمل بلكسر وتأتي على هيئة محددة ومعبأة.",
    "time":"وفر الوقت",
    "timeDesc":"نظم واجهة المستخدم الخاصة بك عن طريق وضع مكونات Board معًا. ستجد كل ما تحتاجه وأكثر بين يديك.",
    "charts":"وضح رؤيتك بالرسوم البيانية",
    "chartsDesc":"يأتي Board مع مكونات متنوعة من الرسوم البيانية لعرض للإحصاءات المختلفة  بشكل أفضل و التي يتم وضعها في واجهة المستخدم.",
    "datatables":"جداول بيانات شاملة",
    "datatablesDesc":"اعرض بياناتك بطريقة منظمة وتحكم فيها بشكل كامل لكل من العميل و معالج الخادم.",
    "brandIdentity":"سلط الضوء على هوية |علامتك التجارية",
    "brandIdentityDesc":"حدد لون الشعار والقالب تبعًا لعلامتك التجارية أثناء بناء لوحة التحكم  الخاصة بك من أجل تحقيق مظهر وشكل متخصصين.",
    "alternativeDark":"قوالب داكنة بديلة",
    "alternativeDarkDesc":"هناك قوالب داكنة من Board التي تمنح مظهرًا مختلفًا. المزيد من القوالب سوف تُرفع في المستقبل.",
    "incorporated":"مكتبات مدمجة",
    "incorporatedDesc":"تمتع بمكتبات الطرف الثالث المختلفة، بما في ذلك التعديل ومكونات الإدخال، لتتماشى مع الشكل العام لBoard.",
    "experienceBoard":"تمتع بتجربة مميزة |مع Board. ",
    "getStarted":"ابدأ الآن!"
  }
}
</i18n>
